export const environment = {
  production: true,
  enableRouterTracing: true,
  enableEncryption: true,
  appId: 'd66599ef-59d7-4ae7-b3ba-3e1e698e606f',
  apiUrl: 'https://api-uat.equitygroupholdings.com',
  appUrl: 'https://servicehub-swift-uat.equitygroupholdings.com',
  adminPortalUrl: 'https://servicehub-admin-portal-uat.equitygroupholdings.com',
  customerOnboardingUrl: 'https://servicehub-customer-onboarding-uat.equitygroupholdings.com',
  customer360Url: 'https://servicehub-customer-360-uat.equitygroupholdings.com',
  cardsPortalUrl: 'https://servicehub-cards-uat.equitygroupholdings.com',
  secugenApi: 'https://localhost:8443',
  secugenLicenseUAT: '3XujEdKBRed5W2e5bnZ4oa3eaDpjmZNF/Un2vjC8Yl/fXGCzVrHNlWqtVexVjQgGK2fmt4+PhVBeT4ptDv62vw==',
  clientId: '44FEC6A5E3F5454',
  PAGE_SIZE: 20,
};
